import {Font} from '@mintdata/mint-kit/api/models/Font';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export class FontConverter extends BaseFieldConverter<Font>
{
    public static readonly TYPEFACE:FieldPath = 'typeface';
    public static readonly WEIGHT:FieldPath = 'weight';
    public static readonly SIZE:FieldPath = 'size.unitsString';
    public static readonly LINE_HEIGHT:FieldPath = 'lineHeight.unitsString';
    public static readonly CHARACTER:FieldPath = 'character.unitsString';
    public static readonly COLOR_HEX:FieldPath = 'color.hex';
    public static readonly COLOR_ALPHA:FieldPath = 'color.alpha';
    public static readonly FONT_STYLE:FieldPath = 'fontStyle';
    public static readonly DECORATION_UNDERLINE:FieldPath = 'decorationUnderline';
    public static readonly DECORATION_CROSSED:FieldPath = 'decorationCrossed';
    public static readonly TRANSFORMATION:FieldPath = 'transformation';
}
